export const USERS_ALLOWED_TO_MARK_SALE_PAID: string[] = [
  "usr-dacb2aa3-608e-4641-bc81-642076d529ae",
  "usr-870069f0-0452-4ad7-b561-6da9cd2ab033",
  "usr-8a00a51e-d87f-4623-9206-81b993282bfd",
];


